module.exports = {
  createCompany: 'Create New Company',
  createCatalog: 'Neuen Katalog erstellen',
  createDomain: 'Create New Domain',
  createWebSpace: 'Create New Webspace',
  createTable: 'Create New Table',
  createLicense: 'Create New License',
  createPrinter: 'Create New Printer',
  createPrintServer: 'Neuen Druckserver erstellen',
  createAccount: 'Create New Account',
  createCallerId: 'Create New CallerID Server',
  createAppRes: 'Create New App Resource',
  createCorporation: 'Create New Corporation',
  createPrintTemplate: 'Create New Print Template',
  createLangMapp: 'Create New Printer Category Language Mapping',
  selectCompany: 'Select Company',
  selectCompanies: 'Select Companies',
  selectDomain: 'Select Domain',
  selectDomainType: 'Select Domain Type',
  selectPrinters: 'Select Printers',
  selectPrinterCategories: 'Wähle Drucker Kategorien',
  selectPrinterCategory: 'Wähle Drucker Kategorie',
  selectTemplateType: 'Select Template Type',
  selectTemplate: 'Select Template',
  selectTemplateImport: 'Select template to import pre- and postfix',
  selectPrintTemplateType: 'Select Print Template Type',
  selectLanguage: 'Select Language',
  selectCategory: 'Select Table Category',
  selectDefaultPrinter: 'Select Default Printer',
  selectRoles: 'Select Roles',
  selectMonth: 'Select Month',
  selectYear: 'Select Year',
  showLogs: 'Show Logs',
  showDetails: 'Show Details',
  showUpdates: 'Show Updates',
  addProperty: 'Add Property',
  selectPropType: 'Select Property Type',
  addTableName: 'Add Table Name',
  prefixLines: 'Add Prefix Lines',
  postfixLines: 'Add Postfix Lines',
  preview: 'Vorschau',
  edit: 'Edit',
  delete: 'Delete',
  activate: 'Activate',
  deactivate: 'Deactivate',
  cancel: 'Cancel',
  close: 'Close',
  view: 'View',
  reset: 'Reset',
  create: 'Create',
  update: 'Update',
  submit: 'Submit',
  save: 'Save',
  generateJson: 'Generate JSON',
  ok: 'Ok',
  selectPlanet: 'Select WebShop Planet',
  selectPayment: 'Select Payment Type',
  selectOrderType: 'Select Order Type',
  selectCatalogVersion: 'Select Catalog Version',
  selectSubscription: 'Select Subscription',
  selectCatalogView: 'Select Catalog View',
  openingHours: 'Add Opening Hours',
  addVat: 'Add Vat Percentage',
  viewMiniLicense: 'View Mini License',
  copyKey: 'Copy Key',
  addLangMapp: 'Add Language Mapping',
  clone: 'Clone',
  showReports: 'Show Reports',
  createCopy: 'Create a Copy',
  generateMonthly: 'Generate Aggregated Monthly',
  generate: 'Generate',
  chargebyMiles: 'Add Charge by Miles',
  chargebyAmount: 'Add Charge by Invoice Amount',
  showAudit: 'Show Audit Logs',
  startDate: 'Select Start Date',
  endDate: 'Select End Date',
  serviceType: 'Selecte Service Type',
  pushConfUpdate: 'Push Config Update',
  selectUrl: 'Select URL',
  createDiscount: 'Create New Discount',
  selectDays: 'Select Days',
  selectOrderTypes: 'Select Order Types',
  selectPaymentMethods: 'Select Payment Methods',
  selectRules: 'Select Dicount Rules',
  resetPassword: 'Reset Password',
  checkValidation: 'Check Validation',
  populate: 'Populate',
  copy: 'kopieren',
  homePage: 'Return to Home Page',
  backup: 'Backup',
  backupConfirm: 'Are you sure you want to restore from this file?',
  no: 'No',
  yes: 'Yes',
  selectAppResType: 'Select Type',
  selectAppResSubModel: 'Select Subscription',
  selectResTrackingTypes: 'Select Resource Tracking Types',
  pushToCorp: 'Push to Corporation',
  createCashRegister: 'Create new register',
  registerReciept: 'Register',
  startReciept: 'Start',
  endReciept: 'End',
  nullReciept: 'Null',
  deleteHtmlHint: 'Delete selected Html Hint?',
  addImage: 'Add new image',
  selectLabel: 'Select Label',
  deleteProperty: 'Delete selected Property?',
  showPaymentOverview: 'Show Payment Overview',
  hidePaymentOverview: 'Hide Payment Overview',
  paymentTerminalCreate: 'Create Payment Terminal',
  paymentServerCreate: 'Zahlungsserver erstellen',
  selectTerminals: 'Terminal auswählen',
  chargebyMeters: 'Add Charge by Meters',
  next: 'Next',
  back: 'Back',
  importCompany: 'Import from other company',
  changeCompany: 'Change company',
  addViews: 'Click to add views',
  addViews1: 'Sicht hinzufügen',
  addAllergens: 'Allergen hinzufügen',
  addPrinters: 'Drucker hinzufügen',
  removePrinters: 'Drucker entfernen',
  addVAT: 'Mehrwertsteuer hinzufügen',
  translate: 'Übersetzen',
  exportCSV: 'Export CSV',
  showAllChildren: 'Zeige alle Kinder',
  hideAllChildren: 'Verstecke alle Kinder',
  copyItem: 'Artikel kopieren',
  massAdd: 'Maßenänderung hinzufügen',
  massRemove: 'Maßenänderung entfernen',
  paste: 'Einfügen',
  importFromParent: 'Von Eltern importieren',
  addlanguage: 'Sprache hinzufügen',
  deleteitem: 'Eintrag löschen',
  editViews: 'Sichten bearbeiten',
  editAllergens: 'Allergene bearbeiten',
  editPrinterCategories: 'Druckkategorien bearbeiten',
  addImage1: 'Bild hinzufügen',
  overwrite: 'überschreiben',
  copyEdit: 'Copy & edit',
  copyCatalog: 'Copy catalog',
  pasteCatalog: 'Paste catalog',
  pasteCatalogTurnOn: 'Turn On Paste Listener',
  pasteCatalogTurnOff: 'Turn Off Paste Listener'
};



// WEBPACK FOOTER //
// ./src/lang/de/actions.js